import styled from '@emotion/styled';
import {observer} from 'mobx-react-lite';
import React from 'react';
import {ETooltip} from 'webapp-lib/Components';
import {mixinFlexCenter} from 'webapp-lib/styling';
import {classy} from 'webapp-lib/utils';

type UserCircleProps = {
  active?: boolean;
  initials: string;
  fullName: string;
};

const UUserCircle = ({
  active,
  initials,
  fullName,
}: UserCircleProps): React.ReactElement => (
  <StyledUserCircle
    className={classy({UserCircle: true, active: Boolean(active)})}
  >
    <ETooltip title={fullName}>
      <span>{initials}</span>
    </ETooltip>
  </StyledUserCircle>
);

export default observer(UUserCircle);

const StyledUserCircle = styled.div`
  width: var(--user-circle-dimension);
  height: var(--user-circle-dimension);
  background-color: var(--color-core-white);
  border: var(--regular-border-width) solid var(--color-core-primary);
  border-radius: 50%;
  font-size: var(--font-size-default);
  color: var(--color-core-primary);

  ${mixinFlexCenter}
  user-select: none;

  &.active {
    background-color: var(--color-state-active);
    border: none;
    color: var(--color-core-white);
  }
`;
